import QorusClient from "@/api/clients/QorusClient";
import Locales from "@/utils/locales";
import { i18n } from "vue-lang-router";
import store from "@/store";

export default class PaymentApi {
  public static config = {
    merchantAccount: process.env.VUE_APP_PSP_MERCHANT_ACCOUNT,
    clientKey: process.env.VUE_APP_PSP_CLIENT_KEY,
    environment: process.env.VUE_APP_PSP_ENVIRONMENT,
    returnUrl: process.env.VUE_APP_PSP_RETURNURL,
    origin: process.env.VUE_APP_PSP_ORIGIN,

  };

  static of(): PaymentApi {
    return new PaymentApi();
  }

  getIP(): string {
    return sessionStorage.getItem("ShopperIP") || "";
  }

  getPaymentMethods(amount): Promise<any> {
    const paymentParams = {
      shopperLocale: Locales.getLocaleCode(i18n.locale),
      merchantAccount: PaymentApi.config.merchantAccount,
      amount: {
        value: amount.amount,
        currency: "EUR",
      },
      channel: "Web",
      countryCode: "FR",
    };

    return QorusClient.client.post("adyen/payment-methods", paymentParams).then(
      (data: any) => {

        return {
          response: data,
          clientKey: PaymentApi.config.clientKey,
          environment: PaymentApi.config.environment.toLowerCase(),
        };
      }, (data) => {
        throw data;
      },
    );
  }

  submitAdditionalDetails(data: any): Promise<any> {
    // logs the request
    // console.log("[payment] initiating payment: ", JSON.stringify(data, null, 2));
    // TODO: @cyril: je ne suis plus sûr si ça affiche le résultat bien formatté si on fait juste ", params" sans le JSON.stringify ?
    return QorusClient.client.post("adyen/submit-additional-details", data).then((data) => {
      //  console.log("[payment] payment initiated: ", JSON.stringify(data, null, 2));

      return data;
    }).catch((err) => {
      // console.log("[payment] payment failed: ", JSON.stringify(err, null, 2));
      throw err ? err.message : null;
    });
    // calls the API

    // logs the response
  }

  initiatePayment(data: any): Promise<any> {

    const shopperReference = data.user?.id;
    const shopperIp = this.getIP();
    const lineItems = data.cart.cartItems.map(item => {
      const offer = item.product.offer;

      return {
        description: item.product.reference,
        quantity: item.quantity,
        taxPercentage: (item.price.taxRate * 100) - 100,
        amountExcludingTax: item.price.taxFree * 100,
        id: offer.id,
        amountIncludingTax: item.price.taxIncluded * 100,
        taxAmount: item.price.taxAmount * 100,
      };
    });

    const paymentParams = {
      shopperStatement: "Air France Shopping",
      shopperLocale: Locales.getLocaleCode(i18n.locale),
      merchantAccount: PaymentApi.config.merchantAccount,
      amount: {
        value: Math.round((data.cart.specialPrice.taxIncluded ? data.cart.specialPrice.taxIncluded : data.cart.totalPrice.taxIncluded) * 100),
        currency: "EUR",
      },
      origin: PaymentApi.config.origin, // required for 3ds2 native flow
      browserInfo: data.data.browserInfo, // required for 3ds2
      channel: "Web",
      countryCode: "FR",
      reference: data.cart.uuid,
      paymentMethod: data.data.paymentMethod,
      returnUrl: PaymentApi.config.returnUrl + "?cartUuid=" + data.cart.uuid,
      lineItems: lineItems,
      shopperIP: shopperIp, // required for 3ds2 native flow
      shopperReference: shopperReference,
      merchantOrderReference: data.cart.uuid,
      additionalData: {
        // RequestedTestAcquirerResponseCode: 4, // Uncomment to test different response codes
      },

    };

    return QorusClient.client.post("adyen/initiate-payment", paymentParams).then((data) => {
      return data;
    }).catch((err) => {
      throw err ? { error: err } : null;
    });

  }

  RetryOrderByUuid(shoppingCartUUID: string) {
    if (store.getters.isAuthenticated) {
      return QorusClient.client.get("shopping-cart/payment-failed/" + shoppingCartUUID)
        .then(
          (data) => {
            return data;
          },
          (data) => {
            throw data;
          },
        );
    } else {
      return Promise.reject(); // Fixme
    }
  }

}